<template>
  <v-row class="patient-information-container">
    <v-col v-if="orderInfoPreview" cols="12">
      <v-row class="patient-information">
        <v-col cols="12" class="header-with-select-box">
          <h3 class="text-primary weight-600">Patient Information</h3>
        </v-col>

        <v-col cols="12" class="text-body-3-1 weight-600 text-primary">PATIENT NAME</v-col>

        <v-col cols="4" sm="2">
          <FeedbackInputWrapper
            :field-id="'patientPrefix'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientPrefix"
            label="patientPrefix">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.patientPrefix"
                type="text"
                placeholder="Prefix"
                label="Prefix"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientPrefix', orderInfoPreview.patientPrefix);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>
        <v-col cols="8" sm="3">
          <FeedbackInputWrapper
            :field-id="'patientFirstName'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientFirstName"
            label="patientFirstName"
            :error-messages="
              props.isEditable && !fieldNotEmpty('patientFirstName') && props.formButtonClicked
                ? 'Please enter patient first name.'
                : null
            ">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientFirstName"
                type="text"
                placeholder="First Name"
                label="First Name*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientFirstName', orderInfoPreview.patientFirstName);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>
        <v-col cols="4" sm="2">
          <FeedbackInputWrapper
            :field-id="'patientMiddleName'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientMiddleName"
            label="patientMiddleName">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.patientMiddleName"
                type="text"
                placeholder="Middle Name"
                label="Middle Name"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientMiddleName', orderInfoPreview.patientMiddleName);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>
        <v-col cols="8" sm="3">
          <FeedbackInputWrapper
            :field-id="'patientLastName'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientLastName"
            :error-messages="
              props.isEditable && !fieldNotEmpty('patientLastName') && props.formButtonClicked
                ? 'Please enter patient last name.'
                : null
            "
            label="patientLastName">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientLastName"
                type="text"
                placeholder="Last Name"
                label="Last Name*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientLastName', orderInfoPreview.patientLastName);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>
        <v-col cols="4" sm="2">
          <FeedbackInputWrapper
            :field-id="'patientSuffix'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientSuffix"
            label="patientSuffix">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.patientSuffix"
                type="text"
                placeholder="Suffix"
                label="Suffix"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientSuffix', orderInfoPreview.patientSuffix);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12">
          <v-divider class="mt-n4" />
        </v-col>

        <v-col cols="12" class="text-body-3-1 weight-600 text-primary mt-n3"> GENERAL INFORMATION</v-col>

        <v-col v-if="!isCmmImport" cols="12" sm="6">
          <FeedbackInputWrapper
            :field-id="'insuranceProvider'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.insuranceProvider"
            label="insuranceProvider">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <div class="position-relative">
                <div
                  v-if="showPayorSearchByBinPcn && props.isEditable"
                  class="position-absolute"
                  style="top: -32px; right: 0; z-index: 1">
                  <v-btn variant="text" size="small" class="text-caption" @click="searchPayorByName">
                    Search BIN/PCN by Insurance Provider
                  </v-btn>
                </div>
                <div ref="insuranceProviderFieldRef">
                  <v-text-field
                    v-model="orderInfoPreview.insuranceProvider"
                    type="text"
                    placeholder="Insurance Provider"
                    label="Insurance Provider"
                    class="lh--force-white-background"
                    :readonly="!props.isEditable"
                    :disabled="!props.isEditable"
                    @input="onInput"
                    @change="
                      (e) => {
                        onChange(e);
                        emit('updateOrderInfoField', 'insuranceProvider', orderInfoPreview.insuranceProvider);
                      }
                    "
                    @focus="onFocus"
                    @blur="onBlur" />
                </div>
                <v-menu
                  v-model="payorNameSearchMenu"
                  :close-on-content-click="false"
                  location="bottom"
                  max-width="600"
                  :activator="insuranceProviderFieldRef">
                  <v-card v-if="payorNameSearchResults.length > 0 || payorNameSearchLoading">
                    <v-list v-if="!payorNameSearchLoading">
                      <v-list-item
                        v-for="(payor, index) in payorNameSearchResults"
                        :key="index"
                        @click="selectPayor(payor)">
                        <v-list-item-title>{{ payor.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <v-list v-else>
                      <v-list-item>
                        <v-list-item-title>Searching...</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" sm="6">
          <FeedbackInputWrapper
            :field-id="'patientMemberId'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientMemberId"
            :error-messages="
              props.isEditable && !fieldNotEmpty('patientMemberId') && props.formButtonClicked
                ? 'Please enter insurance member ID.'
                : null
            "
            label="patientMemberId">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientMemberId"
                type="text"
                placeholder="Insurance Member ID"
                label="Insurance Member ID*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientMemberId', orderInfoPreview.patientMemberId);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col v-if="!isCmmImport" cols="12" sm="6">
          <FeedbackInputWrapper
            :field-id="'benefitType'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.benefitType"
            :error-messages="
              props.isEditable && !fieldNotEmpty('benefitType') && props.formButtonClicked
                ? 'Please select benefit category.'
                : null
            "
            label="benefitType">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-select
                v-model="orderInfoPreview.benefitType"
                :items="Object.keys(benefitTypes).map((key) => ({ value: key, title: benefitTypes[key] }))"
                placeholder="Benefit Category"
                label="Benefit Category*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'benefitType', orderInfoPreview.benefitType);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col v-if="!isCmmImport" cols="12" sm="6" :class="{ 'mb-6': showPayorSearchByBinPcn && props.isEditable }">
          <FeedbackInputWrapper
            :field-id="'insurancePlanType'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.insurancePlanType"
            label="insurancePlanType">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.insurancePlanType"
                type="text"
                placeholder="Insurance Plan Type"
                label="Insurance Plan Type"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'insurancePlanType', orderInfoPreview.insurancePlanType);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col v-if="isCoverMyMeds && !isCmmImport" cols="12" sm="6" md="4">
          <FeedbackInputWrapper
            :field-id="'bin'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.bin"
            :error-messages="
              props.isEditable && !fieldNotEmpty('bin') && props.formButtonClicked
                ? 'Please enter Rx BIN number.'
                : null
            "
            label="bin">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <div class="position-relative">
                <div
                  v-if="showPayorNameSearch && props.isEditable"
                  class="position-absolute"
                  style="top: -32px; right: 0; z-index: 1">
                  <v-btn variant="text" size="small" class="text-caption" @click="searchPayorByBinPcn">
                    Search Insurance Provider by BIN/PCN
                  </v-btn>
                </div>
                <div ref="binFieldRef">
                  <v-text-field
                    v-model="orderInfoPreview.bin"
                    type="text"
                    placeholder="Rx BIN Number"
                    label="Rx BIN Number*"
                    class="lh--force-white-background"
                    :readonly="!props.isEditable"
                    :disabled="!props.isEditable"
                    :error-messages="errorMessages"
                    @input="onInput"
                    @change="
                      (e) => {
                        onChange(e);
                        emit('updateOrderInfoField', 'bin', orderInfoPreview.bin);
                      }
                    "
                    @focus="onFocus"
                    @blur="onBlur" />
                </div>
                <v-menu
                  v-model="payorSearchMenu"
                  :close-on-content-click="false"
                  location="bottom"
                  max-width="600"
                  :activator="binFieldRef">
                  <v-card v-if="payorSearchResults.length > 0 || payorSearchLoading">
                    <v-list v-if="!payorSearchLoading">
                      <v-list-item
                        v-for="(payor, index) in payorSearchResults"
                        :key="index"
                        @click="selectPayor(payor)">
                        <v-list-item-title>{{ payor.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <v-list v-else>
                      <v-list-item>
                        <v-list-item-title>Searching...</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </FeedbackInputWrapper>
        </v-col>
        <v-col v-else-if="!isCmmImport" cols="12" sm="6" md="4">
          <FeedbackInputWrapper
            :field-id="'bin'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.bin"
            label="bin">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <div class="position-relative">
                <div
                  v-if="showPayorSearchByBinPcn && props.isEditable"
                  class="position-absolute"
                  style="top: -32px; right: 0; z-index: 1">
                  <v-btn variant="text" size="small" class="text-caption" @click="searchPayorByName">
                    Search RxBIN/ RxPCN by Insurance Provider
                  </v-btn>
                </div>
                <div ref="binFieldRef">
                  <v-text-field
                    v-model="orderInfoPreview.bin"
                    type="text"
                    placeholder="Rx BIN Number"
                    label="Rx BIN Number"
                    class="lh--force-white-background"
                    :readonly="!props.isEditable"
                    :disabled="!props.isEditable"
                    @input="onInput"
                    @change="
                      (e) => {
                        onChange(e);
                        emit('updateOrderInfoField', 'bin', orderInfoPreview.bin);
                      }
                    "
                    @focus="onFocus"
                    @blur="onBlur" />
                </div>
                <v-menu
                  v-model="payorNameSearchMenu"
                  :close-on-content-click="false"
                  location="bottom"
                  max-width="600"
                  :activator="binFieldRef">
                  <v-card v-if="payorNameSearchResults.length > 0 || payorNameSearchLoading">
                    <v-list v-if="!payorNameSearchLoading">
                      <v-list-item
                        v-for="(payor, index) in payorNameSearchResults"
                        :key="index"
                        @click="selectPayorFromNameSearch(payor)">
                        <v-list-item-title>{{ payor.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <v-list v-else>
                      <v-list-item>
                        <v-list-item-title>Searching...</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col v-if="!isCmmImport" cols="12" sm="6" md="4">
          <FeedbackInputWrapper
            :field-id="'processorControlNumber'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.processorControlNumber"
            label="processorControlNumber">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.processorControlNumber"
                type="text"
                placeholder="Rx PCN"
                label="Rx PCN"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'processorControlNumber', orderInfoPreview.processorControlNumber);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
          <v-alert
            v-if="showPcnWarning"
            density="compact"
            variant="tonal"
            color="warning"
            icon="mdi-alert-outline"
            role="status"
            class="mt-2">
            Rx PCN is empty. Missing PCN may cause downstream claims/billing issues.
          </v-alert>
        </v-col>

        <v-col v-if="!isCmmImport" cols="12" sm="6" md="4">
          <FeedbackInputWrapper
            :field-id="'grpNumber'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.grpNumber"
            label="grpNumber">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.grpNumber"
                type="text"
                placeholder="Group Number (Rx GRP)"
                label="Group Number (Rx GRP)"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'grpNumber', orderInfoPreview.grpNumber);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
          <v-alert
            v-if="showGrpWarning"
            density="compact"
            variant="tonal"
            color="warning"
            icon="mdi-alert-outline"
            role="status"
            class="mt-2">
            Rx Group Number is empty. Missing group may cause downstream claims/billing issues.
          </v-alert>
        </v-col>

        <v-col v-if="isFax" cols="12" sm="9">
          <v-text-field
            v-model="orderInfoPreview.faxDescription"
            type="text"
            placeholder="Fax Description"
            label="Fax Description*"
            class="lh--force-white-background"
            :readonly="true"
            :disabled="true" />
        </v-col>
        <v-col v-if="isFax" cols="12" sm="3">
          <FeedbackInputWrapper
            :field-id="'sendFaxFormTo'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.sendFaxFormTo"
            :error-messages="
              props.isEditable && !phoneValid('sendFaxFormTo') && props.formButtonClicked
                ? 'Please enter a fax number.'
                : null
            "
            label="sendFaxFormTo">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.sendFaxFormTo"
                type="text"
                placeholder="Send Fax Form To"
                label="Send Fax Form To*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'sendFaxFormTo', orderInfoPreview.sendFaxFormTo);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" sm="6">
          <FeedbackInputWrapper
            :field-id="'patientDob'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientDob"
            :error-messages="
              props.isEditable && !dobValid('patientDob') && props.formButtonClicked
                ? 'Please enter patient date of birth.'
                : null
            "
            label="patientDob">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientDob"
                type="date"
                placeholder="Date of Birth"
                label="Date of Birth*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientDob', orderInfoPreview.patientDob);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" sm="6">
          <FeedbackInputWrapper
            :field-id="'patientPhone'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientPhone"
            :error-messages="
              props.isEditable &&
              orderInfoPreview.patientPhone !== null &&
              orderInfoPreview.patientPhone !== '' &&
              !phoneValid('patientPhone') &&
              props.formButtonClicked
                ? 'Please enter a valid phone number.'
                : null
            "
            label="patientPhone">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientPhone"
                type="text"
                placeholder="Phone"
                label="Phone"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientPhone', orderInfoPreview.patientPhone);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12">
          <v-col cols="12" class="text-body-3-1 weight-600 patient-gender-label">Patient Gender*</v-col>
          <FeedbackInputWrapper
            :field-id="'patientGender'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientGender"
            :error-messages="
              props.isEditable && !fieldNotEmpty('patientGender') && props.formButtonClicked
                ? 'Please select patient gender.'
                : null
            "
            label="patientGender">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-radio-group
                v-model="orderInfoPreview.patientGender"
                inline
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientGender', orderInfoPreview.patientGender);
                  }
                "
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur">
                <v-radio label="Male" value="Male" color="accent" />
                <v-radio label="Female" value="Female" color="accent" />
                <v-radio label="Unspecified" value="Unspecified" color="accent" />
              </v-radio-group>
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" class="mt-n4 mb-4">
          <v-divider />
        </v-col>

        <v-col cols="12" class="text-body-3-1 weight-600 text-primary">PATIENT ADDRESS</v-col>

        <v-col cols="12">
          <FeedbackInputWrapper
            :field-id="'patientAddress1'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientAddress1"
            :error-messages="
              props.isEditable && !addressValid('patientAddress1') && props.formButtonClicked
                ? 'Please enter patient address. If it is over 35 characters, please use address line 2.'
                : null
            "
            label="patientAddress1">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientAddress1"
                type="text"
                placeholder="Address Line 1"
                label="Address Line 1*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientAddress1', orderInfoPreview.patientAddress1);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12">
          <FeedbackInputWrapper
            :field-id="'patientAddress2'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientAddress2"
            label="patientAddress2">
            <template #default="{ onInput, onChange, onFocus, onBlur }">
              <v-text-field
                v-model="orderInfoPreview.patientAddress2"
                type="text"
                placeholder="Address Line 2"
                label="Address Line 2"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientAddress2', orderInfoPreview.patientAddress2);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" sm="4">
          <FeedbackInputWrapper
            :field-id="'patientCity'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientCity"
            :error-messages="
              props.isEditable && !fieldNotEmpty('patientCity') && props.formButtonClicked
                ? 'Please enter patient city.'
                : null
            "
            label="patientCity">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientCity"
                type="text"
                placeholder="City"
                label="City*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientCity', orderInfoPreview.patientCity);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" sm="4">
          <FeedbackInputWrapper
            :field-id="'patientState'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientState"
            :error-messages="
              props.isEditable && !fieldNotEmpty('patientState') && props.formButtonClicked
                ? 'Please enter patient state.'
                : null
            "
            label="patientState">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-select
                v-model="orderInfoPreview.patientState"
                :items="states"
                placeholder="Select State"
                label="Patient Insurance State*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientState', orderInfoPreview.patientState);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>

        <v-col cols="12" sm="4">
          <FeedbackInputWrapper
            :field-id="'patientZip'"
            :order-key="orderInfoPreview.orderKey"
            :model-value="orderInfoPreview.patientZip"
            :error-messages="
              props.isEditable && !zipCodeValid('patientZip') && props.formButtonClicked
                ? 'Please enter patient ZIP.'
                : null
            "
            label="patientZip">
            <template #default="{ onInput, onChange, onFocus, onBlur, errorMessages }">
              <v-text-field
                v-model="orderInfoPreview.patientZip"
                type="text"
                placeholder="ZIP"
                label="ZIP*"
                class="lh--force-white-background"
                :readonly="!props.isEditable"
                :disabled="!props.isEditable"
                :error-messages="errorMessages"
                @input="onInput"
                @change="
                  (e) => {
                    onChange(e);
                    emit('updateOrderInfoField', 'patientZip', orderInfoPreview.patientZip);
                  }
                "
                @focus="onFocus"
                @blur="onBlur" />
            </template>
          </FeedbackInputWrapper>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { usaStates } from "@/utils/usaStates";
import { isZipCodeValid, isPhoneNumberValid } from "@/utils/validators";
import FeedbackInputWrapper from "@/components/FeedbackInputWrapper.vue";
import { mainServices } from "@/services/mainServices";
import { useRequirementsStore } from "@/stores/requirementsStore";

const benefitTypes = { medical_benefits: "Medical", pharmacy_benefits: "Pharmacy" };

const states = ref([]);

const emit = defineEmits(["updateOrderInfoField"]);

const props = defineProps({
  orderInfo: {
    type: Object,
    required: true,
  },
  isEditable: {
    type: Boolean,
    default() {
      return false;
    },
  },
  formButtonClicked: {
    type: Boolean,
    default() {
      return false;
    },
  },
});

const orderInfoPreview = ref(props.orderInfo);
const requirementsStore = useRequirementsStore();

const isFax = computed(() => orderInfoPreview.value.submissionMethod === "eFax");
const isCoverMyMeds = computed(() => orderInfoPreview.value.submissionMethod === "CoverMyMeds");
const isCmmImport = computed(() => orderInfoPreview.value.orderSubmission?.isCmmImport);

// Non-blocking inline warnings for missing Rx PCN / Rx Group. Missing values can cause
// downstream claims/billing issues on pharmacy submissions.
const isBlank = (v) => v == null || String(v).trim() === "";
const showPcnWarning = computed(
  () => props.isEditable && !isCmmImport.value && isBlank(orderInfoPreview.value.processorControlNumber)
);
const showGrpWarning = computed(
  () => props.isEditable && !isCmmImport.value && isBlank(orderInfoPreview.value.grpNumber)
);

// Payor name search
const showPayorSearch = ref(false);
const payorSearchMenu = ref(false);
const payorSearchResults = ref([]);
const payorSearchLoading = ref(false);
const insuranceProviderFieldRef = ref(null);
const checkedClientCompanyIds = ref(new Set());

// Show "Search by BIN/PCN" only when Insurance Provider is not filled
const showPayorNameSearch = computed(() => {
  return showPayorSearch.value && props.isEditable && !orderInfoPreview.value.insuranceProvider;
});

// Reverse search by payor name
const showPayorSearchByBinPcn = computed(() => {
  return showPayorSearch.value && props.isEditable && !orderInfoPreview.value.bin;
});
const payorNameSearchMenu = ref(false);
const payorNameSearchResults = ref([]);
const payorNameSearchLoading = ref(false);
const binFieldRef = ref(null);

// Check if client company has payor names roster
const checkIfPayorNamesExist = async () => {
  if (!requirementsStore.clientConfig?.id) {
    // Try to refresh client config if not available
    try {
      await requirementsStore.refreshCurrentUserClientConfig();
    } catch (error) {
      showPayorSearch.value = false;
      return;
    }
  }

  const clientCompanyId = requirementsStore.clientConfig?.id;
  if (!clientCompanyId) {
    showPayorSearch.value = false;
    return;
  }

  // Deduplicate: skip if we've already checked this client company ID
  if (checkedClientCompanyIds.value.has(clientCompanyId)) {
    return;
  }

  // Mark as checked before making the request
  checkedClientCompanyIds.value.add(clientCompanyId);

  // Check if payor names exist using lightweight count endpoint
  try {
    const response = await mainServices.getPayorNamesCount(clientCompanyId);
    showPayorSearch.value = (response.count || 0) > 0;
  } catch (error) {
    showPayorSearch.value = false;
  }
};

const searchPayorByBinPcn = async () => {
  const clientCompanyId = requirementsStore.clientConfig?.id;
  if (!clientCompanyId) {
    return;
  }

  const bin = orderInfoPreview.value.bin || "";
  const pcn = orderInfoPreview.value.processorControlNumber || "";

  if (!bin && !pcn) {
    payorSearchMenu.value = true;
    payorSearchResults.value = [{ title: "Please enter RxBIN or RxPCN to search", value: null, isMessage: true }];
    return;
  }

  payorSearchLoading.value = true;
  payorSearchMenu.value = true;

  try {
    const response = await mainServices.getPayorNamesByBinPcn(clientCompanyId, bin, pcn);
    payorSearchResults.value = response.results.map((c) => ({
      title: `${c.payorName}${c.bin ? ` | Rx BIN: ${c.bin}` : ``}${c.pcn ? ` | Rx PCN: ${c.pcn}` : ``}`,
      value: c.payorName,
      bin: c.bin,
      pcn: c.pcn,
    }));
    if (payorSearchResults.value.length === 0) {
      payorSearchResults.value = [
        { title: "No payor names found for the specified Rx BIN/Rx PCN", value: null, isMessage: true },
      ];
    }
  } catch (error) {
    payorSearchResults.value = [{ title: "Error searching payor names", value: null, isMessage: true }];
  } finally {
    payorSearchLoading.value = false;
  }
};

const selectPayor = (payor) => {
  if (payor.isMessage || !payor.value) {
    return;
  }
  orderInfoPreview.value.insuranceProvider = payor.value;
  emit("updateOrderInfoField", "insuranceProvider", payor.value);

  // Update BIN and PCN if available
  if (payor.bin) {
    orderInfoPreview.value.bin = payor.bin;
    emit("updateOrderInfoField", "bin", payor.bin);
  }
  if (payor.pcn) {
    orderInfoPreview.value.processorControlNumber = payor.pcn;
    emit("updateOrderInfoField", "processorControlNumber", payor.pcn);
  }

  payorSearchMenu.value = false;
  payorSearchResults.value = [];
  payorNameSearchMenu.value = false;
  payorNameSearchResults.value = [];
};

const searchPayorByName = async () => {
  const clientCompanyId = requirementsStore.clientConfig?.id;
  if (!clientCompanyId) {
    return;
  }

  const payorName = orderInfoPreview.value.insuranceProvider || "";

  if (!payorName) {
    payorNameSearchMenu.value = true;
    payorNameSearchResults.value = [
      { title: "Please enter Insurance Provider to search", value: null, isMessage: true },
    ];
    return;
  }

  payorNameSearchLoading.value = true;
  payorNameSearchMenu.value = true;

  try {
    const response = await mainServices.getPayorNamesByName(clientCompanyId, payorName);
    payorNameSearchResults.value = response.results.map((c) => ({
      title: `${c.payorName}${c.bin ? ` | Rx BIN: ${c.bin}` : ``}${c.pcn ? ` | Rx PCN: ${c.pcn}` : ``}`,
      value: c.payorName,
      bin: c.bin,
      pcn: c.pcn,
    }));
    if (payorNameSearchResults.value.length === 0) {
      payorNameSearchResults.value = [
        { title: "No Rx BIN/Rx PCN found for the specified Insurance Provider", value: null, isMessage: true },
      ];
    }
  } catch (error) {
    payorNameSearchResults.value = [{ title: "Error searching payor names", value: null, isMessage: true }];
  } finally {
    payorNameSearchLoading.value = false;
  }
};

const selectPayorFromNameSearch = (payor) => {
  if (payor.isMessage || !payor.value) {
    return;
  }

  // Update BIN and PCN if available
  if (payor.bin) {
    orderInfoPreview.value.bin = payor.bin;
    emit("updateOrderInfoField", "bin", payor.bin);
  }
  if (payor.pcn) {
    orderInfoPreview.value.processorControlNumber = payor.pcn;
    emit("updateOrderInfoField", "processorControlNumber", payor.pcn);
  }

  payorNameSearchMenu.value = false;
  payorNameSearchResults.value = [];
};

// Watch for clientConfig changes
watch(
  () => requirementsStore.clientConfig,
  () => {
    if (requirementsStore.clientConfig?.id) {
      checkIfPayorNamesExist();
    }
  },
  { immediate: true }
);

onMounted(async () => {
  for (let stateData of Object.values(usaStates)) {
    states.value.push(stateData.name);
  }
  // Check if payor names exist on mount
  if (!requirementsStore.clientConfig) {
    await requirementsStore.refreshCurrentUserClientConfig();
  }
  await checkIfPayorNamesExist();
});

// Validations
function fieldNotEmpty(field) {
  const value = orderInfoPreview.value[field];
  return value !== null && value.trim() !== "";
}

function addressValid(field) {
  const value = orderInfoPreview.value[field];
  return value !== null && value.trim() !== "" && value.length <= 35;
}

function zipCodeValid(field) {
  const value = orderInfoPreview.value[field];
  return value !== null && value.trim() !== "" && isZipCodeValid(value);
}

function phoneValid(field) {
  const value = orderInfoPreview.value[field];
  return value !== null && value.trim() !== "" && isPhoneNumberValid(value);
}

function dobValid(field) {
  const value = orderInfoPreview.value[field];
  if (value === null || value.trim() === "") {
    return false;
  }
  const dob = new Date(value);
  const today = new Date();
  return dob < today && dob.getFullYear() > 1900;
}
</script>

<style lang="scss" scoped>
@import "../styles/pages/_patient-information-form.scss";
</style>
